import React, { Suspense } from "react";
import { ContentRoute, LayoutSplashScreen } from "../../../../_metronic/layout";
import { Redirect, Switch } from "react-router-dom";
import { Permissions, PermissionType } from "../../../util/Permissions";
import { CreateBank } from "./create-bank/CreateBank";
import ViewBanks from "./view-banks/ViewBanks";
import { EditBank } from "./edit-bank/EditBank";

export default function BankManagement() {
    return (
        <Suspense fallback={<LayoutSplashScreen />}>
            <div className="py-4 px-6">
                <Switch>
                    {
                        /* Redirect from /theme root URL to /banks */
                        <Redirect
                            exact={true}
                            from="/overview/banks"
                            to="/overview/banks/view"
                        />
                    }
                    <ContentRoute path="/overview/banks/create" permission={Permissions.BANKS} permissionType={PermissionType.CREATE} component={CreateBank} />
                    <ContentRoute path="/overview/banks/edit/:bankRef" permission={Permissions.BANKS} permissionType={PermissionType.UPDATE} component={EditBank} />
                    <ContentRoute path="/overview/banks/view" permission={Permissions.BANKS} permissionType={PermissionType.READ} component={ViewBanks} />
                </Switch>
            </div>
        </Suspense>
    );
}